<template>
    <main :class='content_class' class="content">
        <slot
          name="content"
        >
        </slot>
    </main>
</template>

<script setup>
  import {defineProps } from "vue";

  const props = defineProps({
    content_class : {
      default: 'content',
    },
  })
</script>